import React, { useState, useEffect } from 'react'
import { debounce, throttle } from 'lodash'
import { makeStyles, TextField, Grid } from '@material-ui/core'
import MUIDataTable from 'mui-datatables'
import { useDispatch, useSelector } from 'react-redux'
import { ThemeProvider } from '@material-ui/core/styles'
import moment from 'moment-jalaali'
import { DatePicker } from '@material-ui/pickers'
import { useTranslation } from 'react-i18next'
import { getSalesReport } from '../../app/slices/salesSlice'
import { getMuiThemeWithoutPadding } from '../../utils/TableStyle'
import { getAllPackages } from '../../app/slices/packageSlice'
import muiDefaultOptions from '../../constants/muiTableOptions'
import { thousandSeperator, fixNumbers } from '../../utils/getInitials'
import CustomToolbar from '../../utils/CustomToolbar'

const useStyle = makeStyles((theme) => {
  return {
    linkButton: {
      marginBottom: 10,
    },
    status0: {
      color: theme.palette.primary.light,
    },
    status1: {
      color: theme.palette.secondary.light,
    },
  }
})

const entityType = {
  1: 'کاربر',
  2: 'توضیحات تیکت',
  3: 'بورسیه',
  4: 'درس',
  5: 'بسته ازمون',
  6: 'گواهینامه',
  7: 'دوره آموزشی',
  8: 'ویدیو',
  9: 'استاد',
}

const PAYMENT_STATUS = {
  100: 'جدید',
  101: 'در حال پرداخت',
  102: 'تایید شده',
  103: 'پرداخت موفق',
  104: 'ناموفق',
}

const BANK_NAME = {
  1: 'بانک ملت',
  2: 'بانک سامان',
}

const PAYMENT_ID = 'id'
// const PAYMENT_STATUS_CODE = 'payer'
const PAYMENT_STATUS_CODE = 'status'
const ERROR_MESSAGE = 'errorMessage'
const IPG = 'ipg'
const AMOUNT = 'price'
const DISCOUNT = 'discount'
const ENTITY_TYPE = 'entityType'
const PAYER = 'payer'
const CREATE_DATE = 'createDate'
const ROW = 'row'

export const SalesList = () => {
  const classes = useStyle()
  const dispatch = useDispatch()
  const { t } = useTranslation()
  const sales = useSelector((state) => state.sales.list)
  const count = useSelector((state) => state.sales.totalHits)
  const totalAmount = useSelector((state) => state.sales.totalAmount)
  const role = useSelector((state) => state.user?.role)
  const allPackages = useSelector((state) => state.package.allPackages)
  const [page, setPage] = useState(0)
  const [rowsPerPage, setRowsPerPage] = useState(muiDefaultOptions.rowsPerPage)

  const [paymentId, setPaymentId] = useState(null)
  const [paymentStartDate, setPaymentStartDate] = useState(null)
  const [paymentEndDate, setPaymentEndDate] = useState(null)
  const [paymentStatus, setPaymentStatus] = useState(null)
  const [packageId, setPackageId] = useState(null)

  console.log('totalAmount', totalAmount)

  useEffect(() => {
    dispatch(getSalesReport({
      first: rowsPerPage,
      after: page * rowsPerPage,
      PaymentStatus: parseInt(paymentStatus, 10) || undefined,
      SaleRefrenceId: paymentId || paymentId,
      PackageId: parseInt(packageId, 10) || undefined,
      From: paymentStartDate ? fixNumbers(paymentStartDate.format('YYYY-MM-DD')) || paymentStartDate : null,
      To: paymentEndDate ? fixNumbers(paymentEndDate.format('YYYY-MM-DD')) || paymentEndDate : null,
    }))
  }, [rowsPerPage, page, paymentId, paymentStatus, packageId,
    paymentStartDate, paymentEndDate, totalAmount])

  React.useEffect(() => {
    if ([2, 3].includes(role?.roleId)) {
      dispatch(getAllPackages())
    }
  }, [])

  const COLUMNS = [
    {
      name: ROW,
      label: 'ردیف',
      options: {
        sort: false,
        filter: false,
        filterType: 'textField',
      },
    },
    {
      name: PAYMENT_ID,
      label: 'شناسه پرداخت',
      options: {
        sort: false,
        filter: false,
        filterType: 'textField',
      },
    },
    {
      name: PAYMENT_STATUS_CODE,
      label: 'وضعیت پرداخت',
      options: {
        sort: false,
        filter: true,
        filterOptions: {
          fullWidth: true,
          names: Object.values(PAYMENT_STATUS),
        },
        customBodyRender: (value) => (
          <span className={value === 103 && classes.status0}>
            {PAYMENT_STATUS[value]}
          </span>
        ),
      },
    },
    {
      name: ERROR_MESSAGE,
      label: 'خطا',
      options: {
        sort: false,
        filter: false,
        display: false,
      },
    },
    {
      name: IPG,
      label: 'درگاه پرداخت',
      options: {
        sort: false,
        filter: false,
        customBodyRender: (value) => (
          <p style={{ width: 'auto !important' }}>{BANK_NAME[value]}</p>
        ),

      },
    },
    {
      name: AMOUNT,
      label: 'مبلغ تراکنش',
      options: {
        sort: false,
        filter: false,

      },
    },
    {
      name: CREATE_DATE,
      label: 'تاریخ تراکنش',
      options: {
        customBodyRender: (value) => moment(value)?.format('jYYYY/jMM/jDD'),
        sort: false,
        filter: true,
        filterList: [],
        customFilterListOptions: {
          render: (v) => v.map((l) => l.toUpperCase()),
          update: (filterList, filterPos, index) => {
            console.log('update')
            console.log(filterList, filterPos, index)
            filterList[index].splice(filterPos, 1)
            return filterList
          },
        },
        logic: (location, filters) => {
          if (filters.length) return !filters.includes(location)
          return false
        },
        filterOptions: {
          fullWidth: true,
          display: () => (
            <DatePicker
              className={classes.customInput2}
              id="birthday"
          // toolbarFormat="YYYY/MM/DD"
              name="birthDate"
              okLabel={t('confirm')}
              cancelLabel={t('cancel')}
              clearLabel={t('clean')}
              inputVariant="outlined"
              clearable
              fullWidth
              margin="normal"
              todayLabel
              variant="dialog"
              label="از تاریخ"
              labelFunc={(date) => (date?.isValid ? date.format('jYYYY/jMM/jDD') : '')}
              dir="rtl"
              InputLabelProps={{ dir: 'rtl' }}
              value={paymentStartDate}
              ToolbarComponent={CustomToolbar}
              onChange={(e) => {
                setPaymentStartDate(e)
                console.log('paymentStartDate', e)
              }}
              renderInput={(params) => (
                <TextField
                  {...params}
                  inputProps={
                {
                  ...params.inputsProps,
                  placeholder: 'jYYYY/jMMMM/jDD',
                }
              }
                />
              )}
              DialogProps={{
                className: classes.datePicker,
              }}
            />
          ),
        },
        filterType: 'custom',
      },
    },
    {
      name: DISCOUNT,
      label: ' میزان تخفیف',
      options: {
        sort: false,
        filter: true,
        filterOptions: {
          fullWidth: true,
          display: () => (
            <Grid style={{ width: '100%' }}>
              <DatePicker
                className={classes.customInput2}
                okLabel={t('confirm')}
                cancelLabel={t('cancel')}
                clearLabel={t('clean')}
                id="birthday"
                name="birthDate"
                inputVariant="outlined"
                ToolbarComponent={CustomToolbar}
                clearable
                fullWidth
                margin="normal"
                todayLabel
                variant="dialog"
                label="تا تاریخ"
                labelFunc={(date) => (date?.isValid ? date.format('jYYYY/jMM/jDD') : '')}
                dir="rtl"
                InputLabelProps={{ dir: 'rtl' }}
                value={paymentEndDate}
                onChange={(e) => {
                  setPaymentEndDate(e)
                  console.log('paymentStartDate', paymentEndDate)
                }}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    inputProps={
                    {
                      ...params.inputsProps,
                      placeholder: 'jYYYY/jMMMM/jDD',
                    }
                  }
                  />
                )}
                DialogProps={{
                  className: classes.datePicker,
                }}
              />
            </Grid>
          ),
        },
        filterType: 'custom',
        customBodyRenderLite: (index) => {
          console.log('hbkhbihi')
          const data = sales[index]
          // const hasDiscount = data.amount - data.price !== 0
          return (
            <span className={data?.discount?.code
              ? classes.status0 : classes.status1}
            >
              {data?.discount?.discountPercent || 'ندارد'}
            </span>
          )
        },
      },
    },
    {
      name: DISCOUNT,
      label: ' کد تخفیف',
      options: {
        sort: false,
        filter: false,
        customBodyRenderLite: (index) => {
          const data = sales[index]
          // const hasDiscount = data.amount - data.price !== 0
          return (
            <span className={data?.discount?.code
              ? classes.status0 : classes.status1}
            >
              {data?.discount?.code || 'ندارد'}
            </span>
          )
        },
      },
    },
    {
      name: ENTITY_TYPE,
      label: 'نام آزمون',
      options: {
        sort: false,
        filter: false,
        filterType: 'dropdown',
        filterOptions: {
          names: allPackages?.map?.((item) => item.name),
        },
        customBodyRender: (userPackage) => (`پکیج ${entityType[userPackage]}`),
      },
    },
    {
      name: PAYER,
      label: 'شناسه/کد ملی کاربر',
      options: {
        sort: false,
        filter: false,
        customBodyRender: (payer) => payer.userName,
      },
    },
  ]

  const updatePaymentId = debounce((value) => {
    setPaymentId(value)
  }, 500, { maxWait: 1000 })

  const updateFilters = throttle((state) => {
    const idColumnIdx = state.columns.findIndex(
      (col) => col.name === PAYMENT_ID,
    )

    const dateColumnIdx = state.columns.findIndex(
      (col) => col.name === CREATE_DATE,
    )

    const dateColumnIdx2 = state.columns.findIndex(
      (col) => col.name === DISCOUNT,
    )

    const statusColumnIdx = state.columns.findIndex(
      (col) => col.name === PAYMENT_STATUS_CODE,
    )
    const packageNameColumnIdx = state.columns.findIndex(
      (col) => col.name === ENTITY_TYPE,
    )

    console.log('dateColumnIdx2', state)

    if (state.filterList[dateColumnIdx].length) {
      const filterText = state.filterList[dateColumnIdx][0]
      const index = sales.findIndex((item) => moment(item.createDate)?.format('jYYYY/jMM/jDD') === filterText)
      setPaymentStartDate(sales[index].createDate)
    } else {
      setPaymentStartDate(null)
    }

    if (state.filterList[dateColumnIdx2].length) {
      const filterText = state.filterList[dateColumnIdx2][0]
      const index = sales.findIndex((item) => moment(item.createDate)?.format('jYYYY/jMM/jDD') === filterText)
      setPaymentEndDate(sales[index].createDate)
    } else {
      setPaymentEndDate(null)
    }

    if (state.filterList[idColumnIdx].length) {
      updatePaymentId(state.filterList[idColumnIdx][0])
    } else {
      updatePaymentId(null)
    }

    if (state.filterList[statusColumnIdx].length) {
      const filterText = state.filterList[statusColumnIdx][0]
      const keys = Object.keys(PAYMENT_STATUS)
      const index = keys.findIndex((key) => filterText === PAYMENT_STATUS[key])
      setPaymentStatus(keys[index])
    } else {
      setPaymentStatus(null)
    }

    if (state.filterList[packageNameColumnIdx].length) {
      const filterText = state.filterList[packageNameColumnIdx][0]
      const index = allPackages.findIndex((item) => item.name === filterText)
      setPackageId(allPackages[index].id)
    } else {
      setPackageId(null)
    }
  })

  const resetFilters = () => {
    setPackageId(null)
    setPaymentStatus(null)
    setPaymentId(null)
    setPaymentStartDate(null)
    setPaymentEndDate(null)
  }

  return (
    <ThemeProvider theme={getMuiThemeWithoutPadding}>
      <MUIDataTable
        data={sales}
        columns={COLUMNS}
        options={{
          ...muiDefaultOptions,
          enableNestedDataAccess: '.',
          rowsPerPage,
          page,
          count,
          serverSide: true,
          print: false,
          download: false,
          search: false,

          rowHover: true,
          selectableRows: 'none',
          searchable: false,

          onTableChange: (action, state) => {
            switch (action) {
              case 'changePage': {
                setPage(state.page)
                break
              }
              case 'changeRowsPerPage': {
                setRowsPerPage(state.rowsPerPage)
                break
              }
              case 'filterChange':
                updateFilters(state)
                break
              case 'resetFilters': {
                resetFilters()
                break
              }
              default: {
                return null
              }
            }
            return null
          },
        }}
      />
      <p style={{
        display: 'flex',
        fontWeight: 'bold',
        justifyContent: 'end',
        marginTop: '35px',
        width: '100%',
      }}
      >
        جمع کل
        {': '}
        {thousandSeperator(totalAmount, 0)}
        {' ریال'}
      </p>
    </ThemeProvider>
  )
}

export default SalesList
